import { Checkbox, DataDisplay, Grid, TextField, formatBoolean, pn } from "@compass/core";
import { DiplomaTypeEditResource, DiplomaTypeViewResource, Topic } from "generated/openApi";
import { CrudMode, ValidationErrors } from "@compass/core";
import { Input } from "components";
import produce from "immer";

export const TopicPageBody = (props: {
    crudMode: CrudMode;
    topic: Topic;
    setTopic: (topic: Topic) => void;
    viewResource: DiplomaTypeViewResource;
    editResource: DiplomaTypeEditResource;
    validationErrors: ValidationErrors;
}) => {
    const { crudMode, topic, setTopic, editResource, validationErrors } = props;
    const properties = props.viewResource.properties || [];

    const nameField = () => {
        const propertyName = pn<Topic>("name");
        const property = properties.find((x) => x.propertyName === propertyName);

        return props.crudMode === "view" ? (
            <DataDisplay label={property?.displayName}>{props.topic.name}</DataDisplay>
        ) : (
            <Input
                modelProperty={property}
                errors={props.validationErrors[propertyName]}
                value={props.topic.name}
                onChange={(e) =>
                    props.setTopic(
                        produce(props.topic, (draft) => {
                            draft.name = e.target.value;
                        })
                    )
                }
            />
        );
    };

    const isReferralField = () => {
        const propertyName = pn<Topic>("isReferral");
        const property = properties.find((x) => x.propertyName === propertyName);

        return props.crudMode === "view" ? (
            <DataDisplay label={property?.displayName}>{formatBoolean(props.topic.isReferral)}</DataDisplay>
        ) : (
            <Checkbox
                label={property?.displayName}
                checked={props.topic.isReferral}
                onChange={(e) =>
                    props.setTopic(
                        produce(props.topic, (draft) => {
                            draft.isReferral = e.target.checked;
                        })
                    )
                }
            />
        );
    };

    const isServiceField = () => {
        const propertyName = pn<Topic>("isService");
        const property = properties.find((x) => x.propertyName === propertyName);

        return props.crudMode === "view" ? (
            <DataDisplay label={property?.displayName}>{formatBoolean(props.topic.isService)}</DataDisplay>
        ) : (
            <Checkbox
                label={property?.displayName}
                checked={props.topic.isService}
                onChange={(e) =>
                    props.setTopic(
                        produce(props.topic, (draft) => {
                            draft.isService = e.target.checked;
                        })
                    )
                }
            />
        );
    };

    const isActiveField = () => {
        const propertyName = pn<Topic>("isActive");
        const property = properties.find((x) => x.propertyName === propertyName);

        return props.crudMode === "view" ? (
            <DataDisplay label={property?.displayName}>{formatBoolean(props.topic.isActive)}</DataDisplay>
        ) : (
            <Checkbox
                label={property?.displayName}
                checked={props.topic.isActive || false}
                onChange={(e) =>
                    props.setTopic(
                        produce(props.topic, (draft) => {
                            draft.isActive = e.target.checked;
                        })
                    )
                }
            />
        );
    };

    return (
        <Grid container spacing="lg">
            <Grid item xs={12} md={6}>
                {nameField()}
            </Grid>

            <Grid item xs={4} md={3}>
                {isReferralField()}
            </Grid>

            <Grid item xs={4} md={3}>
                {isServiceField()}
            </Grid>

            <Grid item xs={4} md={3}>
                {isActiveField()}
            </Grid>


        </Grid>
    );
};
